import { CSSProperties } from 'react'

import classNames from 'classnames'

import { useDoubleClick } from '@/hooks/useDoubleClick'

interface TableRowProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLTableRowElement>
  onDoubleClick?: React.MouseEventHandler<HTMLTableRowElement>
  onRightClick?: React.MouseEventHandler<HTMLTableRowElement>
}

export const TableRow: React.FC<TableRowProps> = ({
  className,
  style,
  children,
  onClick,
  onDoubleClick,
  onRightClick,
}) => {
  const handleClick = useDoubleClick(onClick, onDoubleClick)
  return (
    <tr
      className={classNames('data-table-row', className)}
      style={{ ...style }}
      onClick={handleClick}
      onContextMenu={onRightClick}
    >
      {children}
    </tr>
  )
}
